import { hoverBorderCls } from '../ReferenceMusicCard/constants'

import type { FileFormValue } from '@/pages/tad.ai/ai-music-generator/_types/form'

import { usePlayAudio } from '@/pages/tad.ai/_hooks/usePlayAudio'


import { useState, useRef, useEffect } from 'react';
import { api } from '@/utils/api';
import { cls } from 'tagged-classnames-free';
import { CssIcon } from '@/components/CssIcon';
interface AudioCardProps {
  value?: FileFormValue
  onChange?: (value?: FileFormValue) => void
  handleHistory?: () => void
  disabled?: boolean
}

function AudioCard(props: AudioCardProps) {
  const { value, onChange, handleHistory, disabled } = props

  const [file, setFile] = useState('')

  const { mutateAsync: getFileAsync, isLoading } =
    api.reference.get.useMutation()

  const isLoaded = useRef(false)

  const { playing, duration, seek, handlePlay } = usePlayAudio({
    file,
    onLoaded: (sound) => {
      if (!isLoaded.current) {
        isLoaded.current = true
        sound.play()
      }
    },
  })

  useEffect(() => {
    setFile('')
    isLoaded.current = false
  }, [value?.token])

  if (!value || !value?.token) {
    return null
  }

  return (
    <div
      className={cls`bg-f-bg-elevated text-f-text-tertiary flex h-[56px] items-center justify-between gap-2`}
    >
      <div
        className={cls`flex items-center ${hoverBorderCls} size-full justify-center`}
      >
        <div className={cls`flex items-center gap-x-1 text-sm font-medium`}>
          <CssIcon className={cls`i-cus--tad-music-note size-6`} />
          {value.filename}
        </div>
      </div>
      <div
        className={cls`
          flex size-14 shrink-0 items-center justify-center
          ${hoverBorderCls} ${disabled ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
        `}
        onClick={disabled ? undefined : handleHistory}
      >
        <CssIcon className={cls`i-com--history size-6`} />
      </div>
    </div>
  )
}

export default AudioCard
